var currentUrl = window.location.hostname
var licencia
switch(currentUrl.toLowerCase()) {
  case 'localhost':
    licencia = 'Z7BY-11E41P-5P0J0Y-2G5N5F-3Q6O0E-316I0X-490B2Z-645I1Q-3V156R-4M1N6M-282I42-5N2V2J-5S5Y1L-3J511A-1Z2U08-121K'
    break;
  case 'extndes.prinex.com':
    licencia = 'Z7DM-XHJE03-1J3E36-4F6B5Q-325329-2E1P4H-4S4Y5Z-5D145N-2O4J0J-1K4U3A-6N17'
    break;
  case 'extncal.prinex.com':
    licencia = 'Z7CV-XH934U-0K0Y3J-6Q4X0M-0L6J0X-2K6H4T-5P5R6K-6R230Z-455443-030P3S-110S'
    break;
  case 'extnpre.prinex.com':
    licencia = 'Z7UO-XHEH2M-5C1836-1O0V1C-420P1D-39613X-2M1E4A-4Z2109-0D5T2V-1O1454-3Q56'
    break;
  case 'apps.prinex.com':
    licencia = 'Z7PK-XIA66Q-0K012I-2Z6J3H-601P4V-703C1W-6R3X6L-2N3C0Y-1R0D33-0S3759-3R0N'
    break;
}

module.exports = licencia
